<template>
    <pm-3d-animation-viewer v-model="animationViewDialog" :animation-data="animationData" :title="title" />
</template>
<script>
import Pm3dAnimationViewer from "../plan-simple/3d-animation-viewer";
import SimplePlanService from "../../extensions/services/plan-simple-service";
import PlanAnimationService from "../../extensions/services/plan-animation-service";
export default {
    components: {
        Pm3dAnimationViewer,
    },
    data() {
        return ({
            animationViewDialog: false,
            title: "",
        });
    },
    created() {
        this.registerBusEvent("pricelist:previewAnimation", (name) => {
            this.selectTreatment(name);
        });
    },
    methods: {
        selectTreatment(name) {
            const tpl = JSON.parse(JSON.stringify(this.$store.state.localSettings.protocols[name]));
            this.title = this.$t("plan_simple.template_" + this.$store.state.localSettings.protocols[name].title);
            let selectedRegion = 0;
            if (['bridge', 'bridge_implants', 'bridge_implants_one_phase', 'veneer'].includes(name)) selectedRegion = 2;

            // Get steps and status
            const steps = SimplePlanService.getSteps(tpl, selectedRegion);
            const status = SimplePlanService.getStatus(tpl, selectedRegion);

            // Build the animation data
            this.animationData = PlanAnimationService.getData(steps, status, null, true);
            this.animationViewDialog = true;
            // logEvent('treatment_selected', 'treatment', tpl.title);
        },
    },
};
</script>
